// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"6011ca52","316":"88413aa8","351":"50578750","540":"541a9d55","553":"6379a6b5","623":"d0533822","767":"5a7d42fb","788":"99f8af6b","803":"9c57fdaf","813":"502c8cf4","917":"c09ec1fa","964":"cbfe3d66","984":"d7d804a2"}[chunkId] + ".chunk.js";
};